import Rest from "../../../class/tool/Rest";
import DevelopmentRequest from "./DevelopmentRequest";
import FormBuilder from "../../../class/tool/FormBuilder";

class DevelopmentRequestController {
    _rest = new Rest();
    _callback = null;
    _baseURL = "developmentrequests";
    _errors = {
        "title": {
            "empty": "Le titre est obligatoire",
            "wrong": "Le titre doit être compris entre 2 et 30 caractères. Alphanumérique, caractères autorisés : - + ' # & , ."
        },
        "message": {
            "empty": "La description est obligatoire",
            "wrong": "La description doit être comprise entre 2 et 30 caractères. Alphanumérique, caractères autorisés : - + ' # & , ."
        }
	};

	static _states = {
		"WAITING": "En attente",
		"ACCEPTED": "Acceptée",
		"REJECTED": "Rejetée",
	}

    // perform

    setFormValues(object, setValues, formNew) {
		if (formNew) {
			setValues(prev => ({
				...prev,
				title: object.title,
				message: object.message
			}));
		}
		else {
			setValues(prev => ({
				...prev,
				title: object.title,
				message: object.message
			}));
		}
    }
    setFormRows(setRows, formNew) {
        let rows;

		if (formNew) {
			rows = [
				{
					label: "Titre",
					attribute: "title",
					inputType: "text",
					returnType: "string",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "Titre",
					autoComplete: "off",
					needed: true,
					checkData: null
				},
				{
					label: "Message",
					attribute: "message",
					inputType: "richText",
					returnType: "string",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "Description de la demande",
					autoComplete: "off",
					needed: true,
					checkData: null
				}
			];
		}
		else {
			rows = [
				{
					label: "Titre",
					attribute: "title",
					inputType: "text",
					returnType: "string",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "Titre",
					autoComplete: "off",
					needed: true,
					checkData: null
				},
				{
					label: "Message",
					attribute: "message",
					inputType: "richText",
					returnType: "string",
					classnameWrapper: null,
					classnameLabel: null,
					classnameInput: "",
					placeholder: "Description de la demande",
					autoComplete: "off",
					needed: true,
					checkData: null
				}
			];
		}

        setRows(rows);
    }
    returnPostDatas(datas) {
        let datasToPost = {};
        let needed = ["title", "message"];
        let optionals = [];

        for (let i in needed) {
            datasToPost[needed[i]] = datas[needed[i]];
        }

        for (let i in optionals) {
            if (datas[optionals[i]] === undefined || datas[optionals[i]] === null) continue;

            switch (typeof datas[optionals[i]]) {
                case "string":
                    if (datas[optionals[i]].length === 0) continue;
                    break;
                default: break;
            }

            datasToPost[optionals[i]] = datas[optionals[i]];
        }

        return datasToPost;
    }
    returnPutDatas(datas) {
        let datasToPost = {};
        let needed = ["title", "message"];
        let optionals = [];

        for (let i in needed) {
            datasToPost[needed[i]] = datas[needed[i]];
        }

        for (let i in optionals) {
            if (datas[optionals[i]] === undefined || datas[optionals[i]] === null) continue;

            switch (typeof datas[optionals[i]]) {
                case "string":
                    if (datas[optionals[i]].length === 0) continue;
                    break;
                default: break;
            }

            datasToPost[optionals[i]] = datas[optionals[i]];
        }

        return datasToPost;
    }
    returnUpdatesFromCompare(object, datas, compare = true) {
        return FormBuilder.returnUpdates(object, datas, compare)
    }

    hasValidMinimumDatas(values, type, subType = null) {
        let resultData;
		const datas = this.returnPostDatas(values);

		for (let key in datas) {
			resultData = this.checkDataToPost(key, datas[key]);

			if (!resultData.result)
				return false;
		}

		return true;
    }
	okToSend(datas, setEvent) {
		return true;
	}
    checkDataToPost(attribute, value) {
        switch (attribute) {
            case "title": return this.controlTitle(value);
            case "message": return this.controlMessage(value);
            default:
                console.log("Unknown attribute", attribute);

                return {
                    result: false,
                    error: "Unknown attribute"
                };
        }
    }
    checkDataToPut(attribute, value) {
        switch (attribute) {
            case "title": return this.controlTitle(value);
            case "message": return this.controlMessage(value);
            default:
                console.log("Unknown attribute", attribute);

                return {
                    result: false,
                    error: "Unknown attribute"
                };
        }
    }
    controlTitle(value) {
        if (value === undefined || value === null || value.length === 0) {
            return {
                result: false,
                error: this._errors["title"]["empty"]
            };
        }

        return {
            result: true,
            error: null
        };
    }
    controlMessage(value) {
        if (value === undefined || value === null || value.length === 0) {
            return {
                result: false,
                error: this._errors["message"]["empty"]
            };
        }

        return {
            result: true,
            error: null
        };
    }

    // Controllers

    index(state, input, page, perPage, sortingName, sortingValue) {
        this._rest.sendQuery(
            'GET',
            '/' + this._baseURL + "?state=" + state + "&page=" + page + "&perPage=" + perPage + "&sortingName=" + sortingName + "&sortingValue=" + sortingValue + (input !== "" ? "&input=" + input : ""),
            {},
            this.handleIndex)
    }
    handleIndex = (response, error, status) => {
        let listObjects = [];
        let pagination = null;

        if(status === 200) {
            let data

            if (response.data !== undefined && response.data.data !== undefined) {
                if(response.data.total !== undefined) {
                    pagination = {
                        total: response.data.total,
                        from: response.data.from != null ? response.data.from : 0,
                        to: response.data.to != null ? response.data.to : 0,
                        per_page: response.data.per_page,
                        current_page: response.data.current_page,
                        first_page_url: new URL(response.data.first_page_url).search,
                        last_page_url: new URL(response.data.last_page_url).search,
                        next_page_url: response.data.next_page_url !== null ? new URL(response.data.next_page_url).search : null,
                        prev_page_url: response.data.prev_page_url !== null ? new URL(response.data.prev_page_url).search : null
                    }
                }

                data = response.data.data
            }
            else if (response.data)
                data = response.data

            for(let item in data)
                listObjects.push(new DevelopmentRequest(data[item]));
        }

        this._callback(listObjects, error, pagination, status);
    }

    show(id) {
        this._rest._contentType = 'application/json';
        this._rest.sendQuery(
            'GET',
            '/' + this._baseURL + '/' + id,
            {},
            this.handleShow);
    }
    handleShow = (response, error, status) => {
        const object = !error ? new DevelopmentRequest(response.data) : null;
        this._callback(object, error, status);
    }

    post(datas) {
        this._rest._contentType = 'application/json';
        this._rest.sendQuery(
            'POST',
            '/' + this._baseURL,
            datas,
            this.handlePost
        );
    }
    handlePost = (response, error, status) => {
        if (this._callback !== null) {
            this._callback(response, error, status)
        }
    }

    put(object, datas) {
        this._rest._contentType = 'application/json';
        this._rest.sendQuery(
            'PUT',
            '/' + this._baseURL + '/' + object.id,
            datas,
            this.handlePut
        );
    }
    handlePut = (response, error, status) => {
        this._callback(response, error, status)
    }

    delete(object) {
        this._rest._contentType = 'application/json';
        this._rest.sendQuery(
            'DELETE',
            '/' + this._baseURL + '/' + object.id,
            {},
            this.handleDelete);
    }
    handleDelete = (response, error, status) => {
        this._callback(response, error, status)
    }

	fragmentation() {
		this._rest.sendQuery(
			'GET',
			'/' + this._baseURL + "/fragmentation",
			{},
			this.handleFragmentation);
	}
	handleFragmentation = (response, error, status) => {
		this._callback(response, error, status);
	}
}

export default DevelopmentRequestController;
